import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17319 17321"
    {...props}
  >
    <path
      d="M12851 3856c0-731-84-1449-256-2147 2224 1433 3602 3908 3602 6619 0 4340-3529 7872-7873 7872-2708 0-5184-1381-6617-3606 699 171 1417 258 2149 258 4959 0 8995-4036 8995-8996zm-8995 7873c-1067 0-2101-210-3076-624-210-89-454-42-616 120-161 162-209 406-119 616 1414 3330 4664 5480 8279 5480 4965 0 8995-4034 8995-8993 0-3618-2151-6869-5476-8283-214-90-459-42-621 120-157 162-209 405-115 616 412 974 621 2009 621 3075 0 4341-3529 7873-7872 7873z"
      style={{
        fill: "#322d2c",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
